// import 'babel-polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import DisableAutocomplete from '@aacassandra/vue-disable-autocomplete'
import VueHtml2Canvas from 'vue-html2canvas'

import hmt from 'vue-hmt'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrophy, faAward, faMedal } from '@fortawesome/free-solid-svg-icons'
import { faWeixin, faZhihu, faTiktok } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueNoty from 'vuejs-noty'

library.add(faTrophy, faAward, faMedal,
            faWeixin, faZhihu, faTiktok)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.request.use(config => {
  if (store.state.auth.token) {
    config.headers.Authorization = `Bearer ${store.state.auth.token.token}`
  }
  if (store.state.auth.csrf) {
    config.headers.common['X-CSRF-TOKEN'] = store.state.csrf
  }
  return config
})

axios.interceptors.response.use(response => {
  switch (response.data.code) {
  case 200:
    console.log(response.data)
    return response.data
  }
  return response
}, error => {
  if (error.response) {
    console.error(error.response)
    switch (error.response.status){
    case 401:
      console.log('401 logout')
      store.commit('LOGOUT')
    }
  }

  return Promise.reject(error)
})

Vue.prototype.$http = axios
Vue.use(DisableAutocomplete)
// import vwt from 'vue-wechat-title'
// Vue.use(vwt)
// Vue.use(require('vue-wechat-title'))
Vue.use(VueHtml2Canvas)
Vue.use(VueNoty)

window.checkTime = async function(){
  await axios.get('api/time')
    .then(res => {
      let time = +new Date()
      store.commit("SET_TIME", res.data.data-time)
      console.log('checktimefinished')
    });
}
axios.get('/api/game/current')
  .then(res => {
    if(res.data){
      store.commit('SET_PROCEDURE', res.data.state)
      store.commit("SET_GAME_SLUG", res.data.slug)
      store.commit("SET_GAME_YEAR", res.data.slug.slice(0, 4))
      store.commit("SET_ALL_SCORE", res.data.all)
    }
    let options = {
      siteId: store.state.statisticCode,
    }
    Vue.use(hmt, {options, router})

    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  });

